import { useEffect } from 'react'

import { Form, Link } from '@domain-group/suit-theme'

import { useSetState } from '@domain-group/react-hooks'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import type { UseDataStoreItemFormPayload } from '@hooks/useDataStoreItem'
import useActivity from '@hooks/useActivity'

import { ModalCallbacks } from '@modals/EditDataStoreItemModal'

const defaultState = {
  valueVisible: true,
}

type SetState = (state: Partial<typeof defaultState>) => void

const showText = (
  createActivity: ModalCallbacks['createActivity'],
  createActivityPayload: HandleCallbackActionParams,
  setState: SetState,
) => {
  createActivity(createActivityPayload)
  setState({ valueVisible: true })
}

interface SecuredTextProps {
  callbacks: ModalCallbacks,
  dataStoreItemFormPayload: UseDataStoreItemFormPayload,
  secured: boolean,
}

const SecuredText = (props: SecuredTextProps) => {
  const { callbacks, dataStoreItemFormPayload, secured } = props
  const { createActivity } = callbacks || {}

  const [state, setState] = useSetState(defaultState)
  const { valueVisible } = state

  const {
    entityState: {
      label,
      owner_id,
      value,
    },
    handlers,
  } = dataStoreItemFormPayload

  const {
    callbacks: {
      createActivity: createFn,
    },
  } = useActivity()

  useEffect(() => {
    if (secured) setState({ valueVisible: false })
  }, [secured])

  const createActivityPayload = {
    callbacks: {
      action: createFn,
    },
    entityParams: {
      key: 'campaign.viewed_secure_text',
      parameters: { label },
      trackable_id: owner_id,
      trackable_type: 'Campaign',
    },
  }

  return (
    <Form.Field
      label="Value"
      labelRight={!valueVisible ? (
        <Link
          // @ts-expect-error TS2345
          onClick={() => showText(createActivity, createActivityPayload, setState)}
          textProps={{ fontSize: 'small' }}
        >
          Reveal Text
        </Link>
      ) : null}
      marginTop="large"
    >
      {/*
       // @ts-expect-error TS2322 */}
      <textarea
        name="value"
        disabled={!valueVisible}
        style={{ height: 80, resize: 'vertical', width: '100%' }}
        value={valueVisible ? value : '••••••'}
        {...handlers}
      />
    </Form.Field>
  )
}

export default SecuredText
